import React from "react";
import $ from 'jquery';

export default function BtnEdit({id}) {
    return <a className="btn-flat btn-edit" req-id={id}>
        <i className="material-icons">edit</i>
    </a>
}
